export default __webpack_public_path__ + "c4c73df8d4f66716a5a241168918c705.png";